import { render, staticRenderFns } from "./userGiftOrder.vue?vue&type=template&id=46703d42&"
import script from "./userGiftOrder.vue?vue&type=script&lang=js&"
export * from "./userGiftOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46703d42')) {
      api.createRecord('46703d42', component.options)
    } else {
      api.reload('46703d42', component.options)
    }
    module.hot.accept("./userGiftOrder.vue?vue&type=template&id=46703d42&", function () {
      api.rerender('46703d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/userGiftOrder/userGiftOrder.vue"
export default component.exports